import { range } from '../../utils'

import { months } from './constants'
import { Month } from './types'

function isLeapYear(year: number): boolean {
  return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0
}

export function generateCalendarDates(date: Date): Date[] {
  let dates: Date[] = []
  const monthNumber = date.getMonth()
  const monthName = months[monthNumber]
  const year = date.getFullYear()
  switch (monthName) {
    case Month.JAN:
    case Month.MAR:
    case Month.MAY:
    case Month.JUL:
    case Month.AUG:
    case Month.OCT:
    case Month.DEC:
      dates = range(31).map((value) => new Date(Date.UTC(year, monthNumber, value + 1)))
      break

    case Month.APR:
    case Month.JUN:
    case Month.SEP:
    case Month.NOV:
      dates = range(30).map((value) => new Date(Date.UTC(year, monthNumber, value + 1)))
      break

    case Month.FEB:
      if (isLeapYear(year)) {
        dates = range(29).map((value) => new Date(Date.UTC(year, monthNumber, value + 1)))
      } else {
        dates = range(28).map((value) => new Date(Date.UTC(year, monthNumber, value + 1)))
      }
      break

    default:
      break
  }

  let offset: number

  if (dates[0].getDay() === 0) {
    offset = 6
  } else {
    offset = dates[0].getDay() - 1
  }

  return [...Array(offset), ...dates].map((d, index) => {
    if (index < offset) {
      return new Date(Date.UTC(1970, 0, index))
    } else {
      return d
    }
  })
}
